import { render } from "./sidebar-menu.vue?vue&type=template&id=8f807a76&scoped=true"
import script from "./sidebar-menu.vue?vue&type=script&lang=js"
export * from "./sidebar-menu.vue?vue&type=script&lang=js"

import "./sidebar-menu.vue?vue&type=style&index=0&id=8f807a76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f807a76"]])

export default __exports__